<mat-toolbar color="primary" style="z-index: 3; position: absolute;">
    <mat-toolbar-row>
        <span>ProCod</span>
        <span class="example-spacer"></span>
        <button mat-icon-button class="example-icon" routerLink="/login">
        <mat-icon>login</mat-icon>
        </button>
    </mat-toolbar-row> 
</mat-toolbar>